import React from 'react';
import { Form, Input } from '@maxtropy/components';
import { Col, Row, FormInstance } from 'antd';

interface EnergySavingConfigProps {
  isEdit: boolean;
  form: FormInstance<any>;
}

const EnergySavingConfig: React.FC<EnergySavingConfigProps> = ({ isEdit, form }) => {
  return (
    <Row gutter={8}>
      <Col span={24}>
        <Form.Item name="energySavingContent" label="节能降碳说明">
          <Input.TextArea
            disabled={!isEdit}
            placeholder="请输入节能降碳说明内容"
            maxLength={2000}
            showCount
            rows={6}
            style={{ maxWidth: 800 }}
          />
        </Form.Item>
        <div style={{ color: 'rgba(255, 255, 255, 0.45)', fontSize: 12, marginTop: -8, marginLeft: 120 }}>
          <div>使用方法：输入 #Red文本#Red 可将文本显示为红色</div>
          <div>
            支持的颜色：Red(红色)、Orange(橙色)、Yellow(黄色)、Green(绿色)、Blue(蓝色)、
            Purple(紫色)、Black(黑色)、White(白色)、Gray(灰色)、Brown(棕色)、Silver(银色)、Gold(金色)
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default EnergySavingConfig;
